import { render, staticRenderFns } from "./FeatureVote.vue?vue&type=template&id=0ba92740&scoped=true"
import script from "./FeatureVote.vue?vue&type=script&lang=js"
export * from "./FeatureVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba92740",
  null
  
)

export default component.exports